
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-exit",
  components: {},
})
export class IconExit extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconExit;
